import {connect} from 'react-redux';
import FileBlock from './FileBlock';
import {getStepData} from '../../../../../modules/Inspection/actions/steps/getStepData';
import {getFileFromOrder} from '../../../../actions/files/getFile';
import {showGlobalErrorMessage} from '../../../../actions/globalErrorMessage/showGlobalErrorMessage';
import {getFileList} from '../../../../../modules/Inspection/actions/files/getFileList';

export default connect(
  null,
  {
    getStepData,
    getFileFromOrder,
    showGlobalErrorMessage,
    getFileList
  }
)(FileBlock);
